import { Tab } from '@material-ui/core';
import React from 'react';

interface TabWithPermissionsProps {
  key: any;
  label?: string;
  onClick?: () => void;
  hasPermission?: boolean;
}

const TabWithPermissions: React.FC<TabWithPermissionsProps> = ({ hasPermission, ...props }) => {
  return hasPermission ? <Tab {...props}>{props.children}</Tab> : null;
};

export default TabWithPermissions;
